export default "__VITE_ASSET__DVx5iUVo__ 400w, __VITE_ASSET__CAuou0Rq__ 640w, __VITE_ASSET__Cgxo83$t__ 900w";